var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.Return()),expression:"Return()"}],staticClass:"button",attrs:{"to":"/Applet"}},[_c('input',{staticClass:"btn btn-close",attrs:{"type":"button"}})])}
var staticRenderFns = []

export { render, staticRenderFns }